/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Hero_Pill_TasksInputs */



/**
* | output |
* | --- |
* | "Updated 23 tasks after the last run" |
*
* @param {Integrations_Hero_Pill_TasksInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_hero_pill_tasks = /** @type {((inputs?: Integrations_Hero_Pill_TasksInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Hero_Pill_TasksInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("23 Aufgaben nach dem letzten Lauf aktualisiert")
	return /** @type {LocalizedString} */ ("Updated 23 tasks after the last run")
});